import { Action } from '@ngrx/store';

export const SET_TRANSACTION_FROM_QUERY_PARAMS = '[VEHICLE_MAINTENANCE] Set Transaction From Query String';
export class SetTransactionFromQueryParams implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = SET_TRANSACTION_FROM_QUERY_PARAMS;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export const RESET_STATE = '[VEHICLE_MAINTENANCE] Reset State';
export class ResetMenuState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = RESET_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type VehicleMaintenanceAction = SetTransactionFromQueryParams | ResetMenuState;
